module.exports = __webpack_public_path__ + "static/media/link-button.b04c0b60.png";